module.exports = "/src/views/player/captures/assets/attacks.png";